import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import stl from "./AnyQustV2.module.css";
import { onPushDataLayer, onPushDataLayerNew } from "@/utils/events";
import { trackEvents } from "@/common/events/events";
import FaceBookAQSVG from "./anyQuestSvgs/FaceBookAQSVG";
import TwitterAQSVG from "./anyQuestSvgs/TwitterAQSVG";
import InstagramAQSVG from "./anyQuestSvgs/InstagramAQSVG";
import SnapchatAQSVG from "./anyQuestSvgs/SnapchatAQSVG";
import YoutubeQASVG from "./anyQuestSvgs/YoutubeQASVG";
import useWebView from "@hooks/useWebview";
import useContactNumbers from "@hooks/useContactNumbers";
import useIsMobile from "@hooks/useIsMobile";
var AnyQustV2 = function AnyQustV2(_ref) {
  var _ref$isContactUs = _ref.isContactUs,
    isContactUs = _ref$isContactUs === void 0 ? null : _ref$isContactUs,
    _ref$hasSocialLinks = _ref.hasSocialLinks,
    hasSocialLinks = _ref$hasSocialLinks === void 0 ? null : _ref$hasSocialLinks,
    customTitle = _ref.customTitle,
    customWorkingHours = _ref.customWorkingHours,
    customBackgroundStyle = _ref.customBackgroundStyle,
    customPhoneNumber = _ref.customPhoneNumber,
    customWhatsappNumber = _ref.customWhatsappNumber,
    _ref$customLocation = _ref.customLocation,
    customLocation = _ref$customLocation === void 0 ? "Homepage" : _ref$customLocation,
    _ref$hideContainer = _ref.hideContainer,
    hideContainer = _ref$hideContainer === void 0 ? false : _ref$hideContainer,
    _ref$useWhiteDesign = _ref.useWhiteDesign,
    useWhiteDesign = _ref$useWhiteDesign === void 0 ? false : _ref$useWhiteDesign;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var contactNumbers = useContactNumbers();
  var webview = useWebView();
  var isDesktop = !useIsMobile();
  var normalizeNumberForDisplay = function normalizeNumberForDisplay(num) {
    return num === null || num === void 0 ? void 0 : num.replace("+966", "");
  };

  // Use custom values if provided, otherwise fallback to defaults
  var phoneDisplayNumber = normalizeNumberForDisplay(customPhoneNumber) || contactNumbers.callCenterDisplayNumber;
  var phoneCallNumber = customPhoneNumber || contactNumbers.callCenterCallNumber;
  var whatsappNumber = customWhatsappNumber || contactNumbers.whatsappCallNumber;
  var trackingLocation = customLocation;

  // Choose the correct CSS class based on design type
  var containerClass = useWhiteDesign ? stl.callHelpContainerWhite : stl.callHelpContainer;
  var containerStyle = useWhiteDesign ? {} : customBackgroundStyle;
  var openUri = function openUri(link) {
    webview.openUri(link)["catch"](function () {
      window.location.href = link;
    });
  };
  var whatsappClick = function whatsappClick() {
    trackEvents("online_contact", {
      post_id: null,
      contact_type: "whatsapp",
      contact_location: trackingLocation
    });
    onPushDataLayer("event", "communication", "contact_us", "whatsapp");
    onPushDataLayerNew("syarah_events", "contact", "CSRContact");
    openUri("https://wa.me/".concat(whatsappNumber));
  };
  var callClick = function callClick() {
    trackEvents("online_contact", {
      post_id: null,
      contact_type: "call",
      contact_location: trackingLocation
    });
    onPushDataLayer("event", "communication", "contact_us", "call");
    onPushDataLayerNew("syarah_events", "contact", "CSRContact");
    openUri("tel:".concat(phoneCallNumber));
  };
  var facebookClick = function facebookClick() {
    var link = isDesktop ? "https://www.facebook.com/syarah.KSA" : "https://m.facebook.com/syarah.KSA";
    trackEvents("online_contact", {
      post_id: null,
      contact_type: "facebook",
      contact_location: trackingLocation
    });
    openUri(link);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isContactUs && /*#__PURE__*/React.createElement("div", {
    className: [stl.mobileCallUs, "m-show"].join(" ")
  }, /*#__PURE__*/React.createElement("button", {
    className: ["blueBtn"].join(" "),
    onClick: callClick
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Call.svg",
    alt: "",
    className: "en:rotate-90"
  }), /*#__PURE__*/React.createElement("span", null, t("call", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "greenBtn ",
    onClick: whatsappClick
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t("whatsapp", {
    ns: "web_home"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.anyQustContainer
  }, hideContainer && /*#__PURE__*/React.createElement("div", {
    className: containerClass,
    style: containerStyle
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "65px"
    },
    className: "icon-telephoneRed  en:rotate-90"
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  })), /*#__PURE__*/React.createElement("strong", null, customTitle || t("need_help", {
    ns: "web_home"
  })), customWorkingHours ? /*#__PURE__*/React.createElement("p", {
    style: {
      whiteSpace: 'pre-line'
    }
  }, customWorkingHours) : /*#__PURE__*/React.createElement("p", null, t("serve_throughout_week_following_working", {
    ns: "web_home"
  }), /*#__PURE__*/React.createElement("br", null), t("saturday_thursday_9_am_11", {
    ns: "web_home"
  }), /*#__PURE__*/React.createElement("br", null), t("evening_friday_1_pm_11", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.phoneWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: "cursor-pointer",
    onClick: callClick
  }, phoneDisplayNumber)), /*#__PURE__*/React.createElement("span", {
    className: ["cursor-pointer", stl.whatsappBtn].join(" "),
    onClick: whatsappClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-wpImg",
    style: {
      fontSize: "24px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  })), /*#__PURE__*/React.createElement("span", null, t("contact_via_whatsapp", {
    ns: "web_home"
  })))), !hideContainer && isDesktop && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: containerClass,
    style: containerStyle
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "65px"
    },
    className: "icon-telephoneRed  en:rotate-90"
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  })), /*#__PURE__*/React.createElement("strong", null, customTitle || t("need_help", {
    ns: "web_home"
  })), customWorkingHours ? /*#__PURE__*/React.createElement("p", {
    style: {
      whiteSpace: 'pre-line'
    }
  }, customWorkingHours) : /*#__PURE__*/React.createElement("p", null, t("serve_throughout_week_following_working", {
    ns: "web_home"
  }), /*#__PURE__*/React.createElement("br", null), t("saturday_thursday_9_am_11", {
    ns: "web_home"
  }), /*#__PURE__*/React.createElement("br", null), t("evening_friday_1_pm_11", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.phoneWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: "cursor-pointer",
    onClick: callClick
  }, phoneDisplayNumber)), /*#__PURE__*/React.createElement("span", {
    className: ["cursor-pointer", stl.whatsappBtn].join(" "),
    onClick: whatsappClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-wpImg",
    style: {
      fontSize: "24px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  })), /*#__PURE__*/React.createElement("span", null, t("contact_via_whatsapp", {
    ns: "web_home"
  }))))))), hasSocialLinks && /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.contMaxWidth].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.socialLinks
  }, /*#__PURE__*/React.createElement("h2", null, " ", t("follow_receive_last_cars_offers", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer",
    onClick: facebookClick
  }, /*#__PURE__*/React.createElement(FaceBookAQSVG, null)), /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer",
    onClick: function onClick() {
      return openUri("https://twitter.com/Syarah_ksa");
    }
  }, /*#__PURE__*/React.createElement(TwitterAQSVG, null)), /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer",
    onClick: function onClick() {
      return openUri("https://www.instagram.com/Syarah_ksa/");
    }
  }, /*#__PURE__*/React.createElement(InstagramAQSVG, null)), /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer",
    onClick: function onClick() {
      return openUri("https://www.snapchat.com/add/syarah_ksa");
    }
  }, /*#__PURE__*/React.createElement(SnapchatAQSVG, null)), /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer",
    onClick: function onClick() {
      return openUri("https://www.youtube.com/channel/UCAceZ20JD3qef5OQSVc95Bw");
    }
  }, /*#__PURE__*/React.createElement(YoutubeQASVG, null))))));
};
export default AnyQustV2;